import { ExternalLink, Anchor, Flame, Radar } from "lucide-react";

const ALLIANCES = [
  {
    id: "island-gold",
    label: "Island Gold",
    icon: Anchor,
    url:
      "https://eigoo-command.preview.emergentagent.com/?utm_source=fleet&utm_medium=alliance&utm_campaign=flagship",
    tag: "FLAGSHIP",
  },
  {
    id: "siren",
    label: "Siren Hub",
    icon: Flame,
    url:
      "https://siren-storefront.preview.emergentagent.com/?utm_source=fleet&utm_medium=alliance&utm_campaign=siren",
    tag: "STOREFRONT",
  },
  {
    id: "lead-sentry",
    label: "Lead Sentry",
    icon: Radar,
    url:
      "https://lead-sentry-gold.preview.emergentagent.com/?utm_source=fleet&utm_medium=alliance&utm_campaign=leadsentry",
    tag: "SIGNALS",
  },
];

export default function FleetAllianceFooter() {
  return (
    <footer
      data-testid="fleet-alliance-footer"
      className="mt-12 border-t border-[#C9A227]/20 bg-black/40 backdrop-blur-sm"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-10">
        <div className="flex flex-wrap items-start justify-between gap-8">
          <div>
            <div className="text-[10px] tracking-armada text-[#C9A227] font-bold mb-2">
              FLEET ALLIANCE · TRACKED SIGNAL-LINKS
            </div>
            <h4 className="text-xl md:text-2xl font-black tracking-tighter text-white">
              Allied Hulls in the Armada
            </h4>
            <p className="text-xs text-zinc-500 mt-1 max-w-md">
              Cross-fleet handshakes. Each link carries UTM telemetry so signal sources are
              attributed inside Airtable & the Sovereign analytics ledger.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 min-w-[280px]">
            {ALLIANCES.map((a) => {
              const Icon = a.icon;
              return (
                <a
                  key={a.id}
                  data-testid={"alliance-link-" + a.id}
                  href={a.url}
                  target="_blank"
                  rel="noreferrer"
                  className="group flex items-center gap-3 px-4 py-3 rounded-lg border border-white/5 bg-black/30 hover:border-[#C9A227]/50 hover:bg-[#C9A227]/5 transition-all duration-300"
                >
                  <div
                    className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
                    style={{
                      background: "linear-gradient(135deg, rgba(201,162,39,0.18), rgba(201,162,39,0.04))",
                      border: "1px solid rgba(201,162,39,0.40)",
                    }}
                  >
                    <Icon className="w-4 h-4 text-[#C9A227]" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-bold text-white truncate">{a.label}</div>
                    <div className="text-[9px] tracking-wider text-zinc-500 uppercase">{a.tag}</div>
                  </div>
                  <ExternalLink className="w-3.5 h-3.5 text-zinc-600 group-hover:text-[#C9A227] transition flex-shrink-0" />
                </a>
              );
            })}
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/5 flex flex-wrap items-center justify-between gap-3 text-[10px] tracking-wider text-zinc-500">
          <span data-testid="footer-eigoo-badge" className="font-bold text-[#C9A227]">
            EMPOWERED BY EIGOO INC
          </span>
          <span>© {new Date().getFullYear()} EIGOO Armada · Sovereign Command Auth</span>
        </div>
      </div>
    </footer>
  );
}
